// Nexora — scripts propios. Un archivo, vanilla JS, sin librerías externas.

function nxInitReveals() {
  var els = document.querySelectorAll('.nx-reveal:not(.nx-visible)');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('nx-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nx-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el, i) {
    el.style.setProperty('--nx-delay', (i % 6) * 90 + 'ms');
    observer.observe(el);
  });
}

function nxInitComparador() {
  var wraps = document.querySelectorAll('[data-nx-comparador]');
  wraps.forEach(function (wrap) {
    var handle = wrap.querySelector('[data-nx-comparador-handle]');
    var after = wrap.querySelector('[data-nx-comparador-after]');
    if (!handle || !after) return;

    var dragging = false;

    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      after.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }

    handle.addEventListener('pointerdown', function (e) {
      dragging = true;
      handle.setPointerCapture(e.pointerId);
    });
    handle.addEventListener('pointerup', function () { dragging = false; });
    handle.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPos(e.clientX);
    });
    wrap.addEventListener('click', function (e) {
      if (e.target === handle) return;
      setPos(e.clientX);
    });
  });
}

function nxInitVariantes() {
  var forms = document.querySelectorAll('[data-nx-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-nx-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var inputs = form.querySelectorAll('[data-nx-opcion]');
    var idInput = form.querySelector('[data-nx-variant-id]');
    var wrapper = form.closest('[data-nx-producto]');
    var preciosEl = wrapper.querySelectorAll('[data-nx-precio]');
    var precioCompareEl = wrapper.querySelector('[data-nx-precio-comparado]');
    var precioAhorroEl = wrapper.querySelector('[data-nx-precio-ahorro]');
    var botones = wrapper.querySelectorAll('[data-nx-add]');
    var galeriaPrincipal = wrapper.querySelector('[data-nx-galeria-principal]');
    var galeriaMinis = wrapper.querySelectorAll('[data-nx-galeria-mini]');

    function moneda(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      });
    }

    function actualizar() {
      var seleccion = Array.from(inputs).map(function (input) {
        if (input.type === 'radio') {
          var checked = form.querySelector('input[name="' + input.name + '"]:checked');
          return checked ? checked.value : null;
        }
        return input.value;
      });

      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });

      if (!variante) return;

      idInput.value = variante.id;
      preciosEl.forEach(function (el) { el.textContent = moneda(variante.price); });
      if (precioCompareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioCompareEl.textContent = moneda(variante.compare_at_price);
          precioCompareEl.style.display = '';
        } else {
          precioCompareEl.style.display = 'none';
        }
      }
      if (precioAhorroEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          var pct = Math.round(((variante.compare_at_price - variante.price) / variante.compare_at_price) * 100);
          precioAhorroEl.textContent = pct + '% ahorrado';
          precioAhorroEl.style.display = '';
        } else {
          precioAhorroEl.style.display = 'none';
        }
      }
      if (variante.image && galeriaPrincipal) {
        galeriaPrincipal.src = variante.image;
        galeriaPrincipal.alt = variante.image_alt || galeriaPrincipal.alt;
        var coincide = false;
        galeriaMinis.forEach(function (mini) {
          var esta = mini.getAttribute('data-full') === variante.image;
          mini.classList.toggle('nx-activa', esta);
          if (esta) coincide = true;
        });
        if (!coincide) {
          galeriaMinis.forEach(function (mini) { mini.classList.remove('nx-activa'); });
        }
      }
      botones.forEach(function (boton) {
        if (variante.available) {
          boton.disabled = false;
          if (boton.hasAttribute('data-nx-texto-disponible')) {
            boton.textContent = boton.getAttribute('data-nx-texto-disponible');
          }
        } else {
          boton.disabled = true;
          if (boton.hasAttribute('data-nx-texto-agotado')) {
            boton.textContent = boton.getAttribute('data-nx-texto-agotado');
          }
        }
      });
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', actualizar);
    });
  });
}

function nxInitGaleria() {
  var galerias = document.querySelectorAll('[data-nx-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-nx-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-nx-galeria-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        if (!src) return;
        principal.src = src;
        minis.forEach(function (m) { m.classList.remove('nx-activa'); });
        mini.classList.add('nx-activa');
      });
    });
  });
}

function nxInitStickyCompra() {
  var barra = document.querySelector('[data-nx-sticky-compra]');
  var original = document.querySelector('[data-nx-boton-original]');
  if (!barra || !original || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        barra.classList.toggle('nx-visible', !entry.isIntersecting);
      });
    },
    { threshold: 0 }
  );
  obs.observe(original);
}

function nxInitContadores() {
  var contadores = document.querySelectorAll('[data-nx-contador]');
  if (!contadores.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-nx-contador'));
      var dur = 1200;
      var t0 = null;
      function paso(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        el.textContent = Math.round(fin * p).toString();
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
      obs.unobserve(el);
    });
  }, { threshold: 0.4 });
  contadores.forEach(function (el) { obs.observe(el); });
}

document.addEventListener('DOMContentLoaded', function () {
  nxInitReveals();
  nxInitComparador();
  nxInitVariantes();
  nxInitGaleria();
  nxInitStickyCompra();
  nxInitContadores();
});
